module.exports = __webpack_public_path__ + "static/media/ic_qr_code.c9b3d530.svg";